export default {
  // Options.jsx
  items_per_page: '/ الصفحة',
  label_items_per_page: 'Items / page',
  jump_to: 'الذهاب إلى',
  jump_to_confirm: 'تأكيد',
  page: '',

  // Pagination.jsx
  first_page: 'First Page',
  last_page: 'Last Page',
  prev_page: 'الصفحة السابقة',
  next_page: 'الصفحة التالية',
  prev_5: 'خمس صفحات سابقة',
  next_5: 'خمس صفحات تالية',
  prev_3: 'ثلاث صفحات سابقة',
  next_3: 'ثلاث صفحات تالية',
};
